import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { IEvent } from '@app/api/interfaces/event.interface';
import { deleteEvent } from '@app/main/main-screen/store/data/events/events.actions';
import { selectMainProjectId } from '@app/main/main-screen/store/main-selection/main-shared-selection/main-shared-selection.selectors';
import { DialogTrackerService } from '@app/core/services/dialog-tracker/dialog-tracker.service';
import {
  DialogDeleteEventComponent,
  IDialogDeleteEventData,
} from '@app/main/leak-detection/context-menus/dialogs/dialog-delete-event/dialog-delete-event.component';

@Injectable({ providedIn: 'root' })
export class LeakDetectionEventDeleteService {
  private readonly store = inject(Store);
  private readonly dialogTrackerService = inject(DialogTrackerService);

  private readonly projectId = this.store.selectSignal(selectMainProjectId);

  public confirmAndDelete(event: IEvent): void {
    const ref = this.dialogTrackerService.regAndOpen(DialogDeleteEventComponent, {
      ...this.dialogTrackerService.getMainContentDialogConfig(),
      position: 'center',
      width: '26rem',
      data: { serialNo: event.serialNo } satisfies IDialogDeleteEventData,
    });

    ref.onClose.pipe(take(1)).subscribe((confirmed: boolean | undefined) => {
      const projectId = this.projectId();

      if (!confirmed || !projectId) return;

      this.store.dispatch(deleteEvent({ requestId: crypto.randomUUID(), projectId, eventId: event.id }));
    });
  }
}
